module.exports = __webpack_public_path__ + "img/bg.136f6cdb.jpg";